import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  todoDropdown: {
    marginLeft: '4px'
  }
});
export default useStyles;